import { dateTimeToView, dateToView } from "helpers/date";
import React from "react";
import type { WaybillContent, WaybillContentValue } from "sources/waybills";

const fieldLabels: Record<string, string> = {
    billDate: "Дата ЭТрН",
    billNumber: "Номер ЭТрН",
    bidDate: "Дата заявки",
    bidNumber: "Номер заявки",
    isExpeditor: "Экспедитор",
    cargoShipper: "Грузоотправитель",
    customer: "Заказчик",
    cargoReceiver: "Грузополучатель",
    carrier: "Перевозчик",
    shippingAddress: "Адрес доставки",
    drivers: "Водители",
    cargos: "Грузы",
    alternateCargoShipperDocuments: "Документы альтернативного грузоотправителя",
    customerContracts: "Договоры заказчика",
    billDocuments: "Документы ЭТрН",
    cargoDocuments: "Документы на груз",
    shippingDocuments: "Перевозочные документы",
    shipperInstructions: "Указания грузоотправителя",
    vehicle: "Транспортное средство",
    loading: "Погрузка",
    unloadComment: "Комментарий к выгрузке",
    shipperMarks: "Отметки грузоотправителя",
    penalties: "Штрафы",
    fileMeta: "Сведения о файле",
    documentMeta: "Сведения о документе",
    signatory: "Подписант",
    fullName: "Полное наименование",
    inn: "ИНН",
    kpp: "КПП",
    ogrnip: "ОГРНИП",
    foreignerType: "Тип иностранного лица",
    country: "Страна",
    foreignerId: "Идентификатор иностранного лица",
    foreignerDocumentType: "Тип документа иностранного лица",
    foreignerDocumentNumber: "Номер документа иностранного лица",
    foreignerDocumentDate: "Дата документа иностранного лица",
    address: "Адрес",
    contact: "Контакты",
    otherInfo: "Дополнительная информация",
    about: "Сведения",
    readableAddress: "Адрес",
    garCode: "Код ГАР",
    postalCode: "Индекс",
    regionCode: "Код региона",
    district: "Район",
    city: "Город",
    locality: "Населённый пункт",
    street: "Улица",
    house: "Дом",
    building: "Строение",
    apartment: "Помещение",
    countryCode: "Код страны",
    foreignAddressText: "Адрес за рубежом",
    addressComment: "Комментарий к адресу",
    gln: "GLN",
    latitude: "Широта",
    longitude: "Долгота",
    phoneNumbers: "Телефоны",
    emails: "Электронная почта",
    otherContacts: "Другие контакты",
    firstName: "Имя",
    lastName: "Фамилия",
    patronymic: "Отчество",
    licenseSeries: "Серия водительского удостоверения",
    licenseNumber: "Номер водительского удостоверения",
    licenseIssueDate: "Дата выдачи водительского удостоверения",
    driverWaybills: "Путевые листы водителя",
    name: "Наименование",
    number: "Номер",
    date: "Дата",
    documentId: "Идентификатор документа",
    additionalInfo: "Дополнительная информация",
    code: "Код",
    condition: "Состояние",
    placesCount: "Количество мест",
    grossWeight: "Масса брутто, кг",
    netWeight: "Масса нетто, кг",
    packagingType: "Тип упаковки",
    packageMethod: "Способ упаковки",
    informationFields: "Дополнительные поля",
    hazards: "Опасные грузы",
    unNumber: "Номер ООН",
    hazardClass: "Класс опасности",
    fileId: "Идентификатор файла",
    items: "Поля",
    identifier: "Идентификатор",
    value: "Значение",
    routeText: "Маршрут",
    deliveryDateTime: "Дата и время доставки",
    deliveryDeadline: "Срок доставки",
    readdressingPerson: "Ответственный за переадресовку",
    readdressingContact: "Контакты для переадресовки",
    authorityTransferDocuments: "Документы о передаче полномочий",
    speedLimit: "Ограничение скорости",
    transportationStandards: "Условия перевозки",
    temperatureMin: "Минимальная температура",
    temperatureMax: "Максимальная температура",
    humidityMin: "Минимальная влажность",
    humidityMax: "Максимальная влажность",
    reloadingForbidden: "Перегрузка запрещена",
    sealInfo: "Сведения о пломбе",
    mainVehicle: "Основное транспортное средство",
    trailers: "Прицепы",
    specialPermits: "Специальные разрешения",
    registrationNumber: "Государственный номер",
    ownershipType: "Вид владения",
    certificateNumber: "Номер свидетельства",
    vin: "VIN",
    type: "Тип",
    model: "Модель",
    capacityRaw: "Грузоподъёмность",
    volumeRaw: "Объём",
    leaseDocuments: "Документы аренды",
    validUntil: "Действует до",
    loaderParticipant: "Участник погрузки",
    plannedLoadingDate: "Плановая дата погрузки",
    factArrivalDate: "Фактическое прибытие",
    factLeaveDate: "Фактическое убытие",
    grossWeightRaw: "Масса брутто, кг",
    massMethod: "Способ определения массы",
    cargoSpacesNumber: "Количество грузовых мест",
    tareStateRaw: "Состояние тары",
    packagingStateRaw: "Состояние упаковки",
    bodyStateRaw: "Состояние кузова",
    position: "Должность",
    status: "Статус",
    attorneySystemInfo: "Система доверенности",
    attorneyId: "Идентификатор доверенности",
    attorneyNumber: "Номер доверенности",
    attorneyDate: "Дата доверенности",
    dateTime: "Дата и время",
    circumstances: "Обстоятельства",
    acts: "Акты",
    weighingActs: "Акты взвешивания",
    exchangeRateDate: "Дата курса валюты",
    currencyPenaltySize: "Размер штрафа в валюте",
    roublesPenaltySize: "Размер штрафа в рублях",
    currencyCode: "Код валюты",
    currencyName: "Валюта",
    exchangeRate: "Курс",
    calculation: "Расчёт",
    calculationActualBasis: "Основание расчёта",
    programVersion: "Версия программы",
    formatVersion: "Версия формата",
    otherRecipientIds: "Другие получатели",
    documentCode: "Код документа",
    cargoSenderExchangeFileDate: "Дата файла грузоотправителя",
    cargoSenderExchangeFileTime: "Время файла грузоотправителя",
    economicLifeDocumentName: "Наименование документа",
    economicEntityName: "Наименование экономического субъекта",
    economicEntityBasisDocuments: "Документы-основания",
    exchangeFileId: "Идентификатор файла обмена",
    exchangeFileDate: "Дата файла обмена",
    exchangeFileTime: "Время файла обмена",
    operationContent: "Содержание операции",
    shipperInformationFields: "Поля грузоотправителя",
    cargoInformationFields: "Поля груза",
    shipperInstructionsInformationFields: "Поля указаний грузоотправителя",
    vehicleInformationFields: "Поля транспортного средства",
    cargoLoadInformationFields: "Поля погрузки",
    shipperMarksInformationFields: "Поля отметок грузоотправителя",
    factEnteredAt: "Факт прибытия",
    factLeftAt: "Факт убытия",
    factLoadUnloadAt: "Факт погрузки или выгрузки",
    cargoConditionNotes: "Замечания по состоянию груза",
    cargoWeightNotes: "Замечания по массе груза",
    cargoPlacesNotes: "Замечания по грузовым местам",
    loadingUnloadingNotes: "Замечания по погрузке или выгрузке",
    note: "Примечание",
};

const hasContent = (value: WaybillContentValue | undefined): boolean => {
    if (value === null || value === undefined || value === "") {
        return false;
    }
    if (Array.isArray(value)) {
        return value.some(hasContent);
    }
    if (typeof value === "object") {
        return Object.values(value).some(hasContent);
    }
    return true;
};

const isObject = (value: WaybillContentValue): value is WaybillContent =>
    typeof value === "object" && value !== null && !Array.isArray(value);

const contentKeys = new WeakMap<WaybillContent, number>();
let nextContentKey = 1;

const getContentKey = (content: WaybillContent) => {
    const existingKey = contentKeys.get(content);
    if (existingKey) {
        return existingKey;
    }
    const key = nextContentKey++;
    contentKeys.set(content, key);
    return key;
};

const labelFor = (key: string) => fieldLabels[key] || key;

const isDateKey = (key: string) => /(Date|At|Deadline|ValidUntil|dateTime)$/i.test(key);

const formatScalar = (key: string, value: string | number | boolean) => {
    if (typeof value === "boolean") {
        return value ? "Да" : "Нет";
    }
    if (typeof value === "string" && isDateKey(key) && /^\d{4}-\d{2}-\d{2}/.test(value)) {
        return value.includes("T") ? dateTimeToView(value) : dateToView(value);
    }
    return String(value);
};

interface StructuredContentProps {
    content: WaybillContent;
    path?: string;
    depth?: number;
}

export const StructuredWaybillContent = ({ content, path = "content", depth = 0 }: StructuredContentProps) => {
    const entries = Object.entries(content).filter(([, value]) => hasContent(value));
    const scalarEntries = entries.filter(([, value]) => !Array.isArray(value) && !isObject(value!));
    const nestedEntries = entries.filter(([, value]) => Array.isArray(value) || isObject(value!));

    return (
        <>
            {scalarEntries.length > 0 && (
                <table className="table table-sm mb-2">
                    <tbody>
                        {scalarEntries.map(([key, value]) => (
                            <tr key={`${path}-${key}`}>
                                <td className="text-muted w-25">{labelFor(key)}</td>
                                <td className={key === "unloadComment" ? "white-space-pre-line text-break" : undefined}>
                                    {formatScalar(key, value as string | number | boolean)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            {nestedEntries.map(([key, value]) => {
                const values = (Array.isArray(value) ? value.filter(hasContent) : [value]).filter(
                    (item): item is WaybillContentValue => item !== undefined,
                );
                const scalarValues = values.filter((item) => !isObject(item));
                const objectValues = values.filter(isObject);
                const objectOccurrences = new Map<number, number>();
                const objectEntries = objectValues.map((item) => {
                    const objectKey = getContentKey(item);
                    const occurrence = (objectOccurrences.get(objectKey) || 0) + 1;
                    objectOccurrences.set(objectKey, occurrence);
                    return { item, contentKey: `${objectKey}-${occurrence}` };
                });
                return (
                    <section className={depth === 0 ? "mb-4" : "mb-3 ml-3"} key={`${path}-${key}`}>
                        <div
                            className={depth === 0 ? "font-weight-bold py-2 mb-2" : "font-weight-bold text-muted mb-2"}
                        >
                            {labelFor(key)}
                        </div>
                        {scalarValues.length > 0 && (
                            <div className="mb-2">
                                {scalarValues
                                    .map((item) => formatScalar(key, item as string | number | boolean))
                                    .join(", ")}
                            </div>
                        )}
                        {objectEntries.map(({ item, contentKey }, index) => (
                            <div
                                key={`${path}-${key}-${contentKey}`}
                                className={index < objectValues.length - 1 ? "border-bottom mb-3 pb-3" : ""}
                            >
                                {objectValues.length > 1 && (
                                    <div className="text-muted small mb-1">Элемент {index + 1}</div>
                                )}
                                <StructuredWaybillContent
                                    content={item}
                                    path={`${path}-${key}-${contentKey}`}
                                    depth={depth + 1}
                                />
                            </div>
                        ))}
                    </section>
                );
            })}
        </>
    );
};

/** Render the consignee's full unload comment separately from driver title remarks. */
export const WaybillUnloadComment = ({ unloadComment }: Pick<WaybillContent, "unloadComment">) => {
    if (!unloadComment) {
        return null;
    }

    return (
        <div className="mt-2 mb-2 pt-2 border-top">
            <div className="font-weight-bold mb-1">Комментарий к выгрузке</div>
            <div className="white-space-pre-line text-break">{unloadComment}</div>
        </div>
    );
};

export const WaybillContentView = ({ content }: { content: WaybillContent }) => (
    <section className="card mb-4">
        <div className="card-header py-2 font-weight-bold">Содержание ЭТрН</div>
        <div className="card-body py-3 font-size-14">
            <StructuredWaybillContent content={content} />
        </div>
    </section>
);
